import type { FinancialViewRow } from "../types";

export const collectRowIds = (
	rows: FinancialViewRow[],
	shouldInclude: (row: FinancialViewRow) => boolean = () => true,
): string[] => {
	const ids: string[] = [];
	const walk = (row: FinancialViewRow) => {
		if (!row.children || row.children.length === 0) return;
		if (shouldInclude(row)) ids.push(row.id);
		for (const child of row.children) walk(child);
	};
	for (const row of rows) walk(row);
	return ids;
};

export const collectExpandableRowIds = (rows: FinancialViewRow[]): string[] => collectRowIds(rows);
